export enum FilterType {
  Datum = 'datum',
  Program = 'program',
}



// WEBPACK FOOTER //
// ./src/app/enums/filter-type.enum.ts